import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clipboard, ClipboardCheck } from 'lucide-react';
import { ListButton, Text } from '@companion-professional/components';
import { CheckupRequestInfo, SurveyInfo } from '@companion-professional/dctypes';
import { cn } from '@companion-professional/webutils';
import { getSurveyPathForCheckup } from '../../lib/surveyPath';

interface SurveyListItemProps {
  survey: SurveyInfo;
  checkupRequest: CheckupRequestInfo;
}

// SurveyListItem displays a single survey in a list of surveys that the user select to fill out for a checkup.
export const SurveyListItem: FunctionComponent<SurveyListItemProps> = ({ survey, checkupRequest }) => {
  const navigate = useNavigate();
  const answeredDetails =
    checkupRequest?.answered_surveys && checkupRequest.answered_surveys.find((s) => s.survey_id === survey.survey_id);

  return (
    <ListButton
      onClick={() => navigate(getSurveyPathForCheckup(survey.survey_id, checkupRequest))}
      Icon={answeredDetails ? ClipboardCheck : Clipboard}
      iconClassName={cn({ 'text-destructive': !answeredDetails })}
    >
      {survey.title || survey.name}
      {answeredDetails ? (
        <Text as="span" size="sm" tone="muted" className="ml-2">
          (complete)
        </Text>
      ) : null}
    </ListButton>
  );
};
